export default __webpack_public_path__ + "static/media/twoBottomLeft.42ec2df0.png";